<template>
  <div class="resultItem">
    <div class="title">{{itemData.lectureInfo.lectureName}}</div>
    <div class="lecturer">主讲人：
      <tag-icon :data="{text: itemData.lectureInfo.lecturer, color: '#ff7777'}" @click.native.stop="search(4, itemData.lectureInfo.lecturer)"></tag-icon>
    </div>
    <div class="field-box" v-if="itemData.lectureInfo.associatedField && itemData.lectureInfo.associatedField.length > 0">
      相关领域：
      <template v-for="(item, idx) in itemData.lectureInfo.associatedField">
        <tag-icon :key="idx" :data="{text: item, color: '#00FF00'}" @click.native.stop="search(2, item)"></tag-icon>
      </template>
    </div>
    <div class="tag-box" v-if="itemData.tags && itemData.tags.length > 0">
      相关标签：
      <template v-for="(item, idx) in itemData.tags">
        <tag-icon :key="idx" :data="{text: item, color: '#ADD8E6'}" @click.stop.native="search(3, item)"></tag-icon>
      </template>
    </div>
    <div v-show="showDetail && itemData.recommenderInfo.id" class="recommender">
      推荐人：
      <tag-icon :data="{text: itemData.recommenderInfo.id, color: '#eeeeee'}" @click.native.stop="search(5, itemData.recommenderInfo.id)"></tag-icon>
    </div>
    <div v-show="showDetail && itemData.recommenderInfo.reason" class="recommend-reason">
      “{{itemData.recommenderInfo.reason}}”
    </div>
    <div
      class="url"
      @click="gotoUrl(itemData.sourceInfo.url)"
      @mouseenter="iconHover"
      @mouseleave="iconHoverLeave"
    >直接查看课程</div>
    <div
      :class="showDetail?'detail-btn-box-2':'detail-btn-box-1'"
      @mouseenter="iconHover"
      @mouseleave="iconHoverLeave"
      @click="showDetail=!showDetail"
    >
      <span v-show="!showDetail">详情</span>
      <span v-show="showDetail">收起</span>
      <div class="detail-icon-1" v-show="!showDetail"></div>
      <div class="detail-icon-2" v-show="showDetail"></div>
    </div>
  </div>
</template>

<script>
import TagIcon from '@/components/TagIcon'
import bus from '@/assets/eventBus'
export default {
  props: ['data'],
  components: {
    TagIcon
  },
  data () {
    return {
      itemData: this.data,
      showDetail: false
    }
  },
  mounted () {
  },
  methods: {
    iconHover () {
      bus.$emit('cursorFocus')
    },
    iconHoverLeave () {
      bus.$emit('cursorFocusRelease')
    },
    gotoUrl (url) {
      window.open(url)
    },
    search (type, text) {
      if (text === '') { return }
      const params = {
        type: type,
        text: text
      }
      this.$router.push({
        path: '/search' + '?_=' + (new Date()).getTime(),
        query: params
      })
    }
  }
}

</script>

<style scoped lang="scss">
.resultItem {
  position: relative;
  flex-shrink: 0;
  width: 90%;
  /*height: 150px;*/
  /*background-color: blue;*/
  margin: 18px 0;
  box-sizing: border-box;
  border: 3px solid white;
  color: white;
  padding: 9px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  transition: all 0.3s;
  .title {
    font-size: 30px;
    font-weight: bold;
  }
  .lecturer {
    margin-top: 9px;
    display: flex;
    align-items: center;
  }
  .major-box {
    margin-top: 6px;
    display: flex;
    align-items: center;
  }
  .field-box {
    margin-top: 6px;
    display: flex;
    align-items: center;
  }
  .tag-box {
    margin-top: 6px;
    display: flex;
    align-items: center;
  }
  .recommender {
    margin-top: 6px;
    display: flex;
    align-items: center;
  }
  .recommend-reason {
    margin-top: 9px;
    max-width: 90%;
    background-color: rgba(255, 255, 255, 0.3);
    padding: 9px;
    font-style: italic;
  }
  .url {
    color: black;
    font-size: 25px;
    background-color: orange;
    padding: 3px 9px;
    border-radius: 10px;
    margin-top: 6px;
    transition: all 0.3s;
    font-weight: bold;
  }
  .url:hover {
    filter: brightness(150%);
    box-shadow: 0 0 10px white;
    transition: all 0.3s;
  }
  .detail-btn-box-1, .detail-btn-box-2 {
    position: absolute;
    right: 9px;
    bottom: 9px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 15px;
    .detail-icon-1, .detail-icon-2 {
      margin-top: 3px;
      width: 20px;
      height: 10px;
      background-color: white;
      clip-path: polygon(0 0, 100% 0, 50% 100%);
    }
    .detail-icon-2 {
      clip-path: polygon(0 100%, 50% 0, 100% 100%);
    }
  }
  .detail-btn-box-2 {
    top: 9px;
  }
}
.resultItem:hover {
  /*animation: border-breath ease-in-out 2s infinite;*/
  border-color: lightblue;
  box-shadow: 0 0 20px lightblue;
  transition: all 0.3s;
}
@keyframes border-breath {
  from {
    border-color: white;
    box-shadow: 0 0 0 black;
  }
  50% {
    border-color: lightblue;
    box-shadow: 0 0 20px white;
  }
  to {
    border-color: white;
    box-shadow: 0 0 0 black;
  }
}
</style>
